import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from '../components/Reveal';
import PageHeader from '../components/PageHeader';
import { images, timeline } from '../mock';

const History = () => {
  return (
    <div>
      <PageHeader
        eyebrow="History & Development"
        title="Nine decades of study"
        subtitle="From the first 1935 geologic survey to modern environmental permitting - a well-documented, high-purity deposit."
        image={images.quarry}
      />

      <section className="py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="eyebrow text-amber-700 mb-4">Timeline</div>
            <h2 className="font-display text-3xl md:text-4xl font-medium text-neutral-900 mb-16">
              A documented exploration record.
            </h2>
          </Reveal>

          <div className="relative">
            <div className="absolute left-[11px] md:left-1/2 top-2 bottom-2 w-px bg-neutral-200 md:-translate-x-1/2" />
            <div className="space-y-12">
              {timeline.map((t, i) => (
                <Reveal key={i} delay={(i % 2) * 80}>
                  <div className={`relative flex md:items-center gap-8 md:gap-0 ${i % 2 === 0 ? 'md:fl-row' : 'md:flex-row-reverse'} md:flex`}>
                    <div className="absolute left-0 md:left-1/2 top-1.5 md:top-1/2 w-6 h-6 md:-translate-x-1/2 md:-translate-y-1/2 rounded-full bg-white border-2 border-amber-700 flex items-center justify-center z-10">
                      <span className="w-2 h-2 rounded-full bg-amber-700" />
                    </div>
                    <div className={`pl-12 md:pl-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-16 md:text-right' : 'md:pl-16 md:ml-auto'}`}>
                      <div className="font-display text-3xl font-bold text-neutral-900">{t.year}</div>
                      <p className="mt-3 text-neutral-600 leading-relaxed">{t.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-neutral-950 py-24">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Reveal>
            <h2 className="font-display text-3xl md:text-4xl font-medium text-white">
              Advancing exploration today.
            </h2>
            <p className="mt-5 text-neutral-400 leading-relaxed">
              Whitemoon is currently advancing near-term development and production-restart scenarios.
            </p>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 bg-amber-500 text-white px-9 py-4 eyebrow hover:bg-amber-600 transition-colors duration-300">
              Get in touch <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default History;
